/* VIPet Store — let visitors drag the floating WhatsApp and accessibility
   buttons anywhere on the screen. A short tap still works as before; moving
   the finger/mouse more than a few pixels drags the button instead, and the
   spot is remembered in this browser. The accessibility panel opens next to
   wherever its button was parked. */
(function () {
  var MARGIN = 8;         // keep buttons this far from the screen edge
  var THRESHOLD = 6;      // px of movement before a press becomes a drag
  var SUPPRESS_MS = 400;  // swallow the click that follows a drag

  var suppressUntil = 0;
  var suppressEl = null;

  var style = document.createElement('style');
  style.textContent =
    '.vp-draggable{touch-action:none;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}' +
    '.vp-dragging{cursor:grabbing!important;transition:none!important}';
  document.head.appendChild(style);

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  // Theme CSS pins these with !important, so inline values need it too.
  function place(el, x, y) {
    var maxX = Math.max(MARGIN, window.innerWidth - el.offsetWidth - MARGIN);
    var maxY = Math.max(MARGIN, window.innerHeight - el.offsetHeight - MARGIN);
    x = clamp(x, MARGIN, maxX);
    y = clamp(y, MARGIN, maxY);
    el.style.setProperty('left', Math.round(x) + 'px', 'important');
    el.style.setProperty('top', Math.round(y) + 'px', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
  }

  // Stored as a fraction of the free space, so a button parked in a corner
  // stays in that corner after rotating the phone or resizing the window.
  function freeSpace(el) {
    return {
      x: window.innerWidth - el.offsetWidth - 2 * MARGIN,
      y: window.innerHeight - el.offsetHeight - 2 * MARGIN
    };
  }

  // Once parked, the button is positioned with a percentage-based calc() so
  // the browser keeps it on screen through any resize or rotation by itself,
  // without relying on a resize event.
  function park(el, rx, ry) {
    var w = el.offsetWidth + 2 * MARGIN;
    var h = el.offsetHeight + 2 * MARGIN;
    el.style.setProperty('left', 'calc(' + MARGIN + 'px + (100% - ' + w + 'px) * ' + rx.toFixed(4) + ')', 'important');
    el.style.setProperty('top', 'calc(' + MARGIN + 'px + (100% - ' + h + 'px) * ' + ry.toFixed(4) + ')', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
  }

  function load(key) {
    try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
  }

  function store(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function restore(el, key) {
    var saved = load(key);
    if (!saved || typeof saved.rx !== 'number' || typeof saved.ry !== 'number') return false;
    park(el, clamp(saved.rx, 0, 1), clamp(saved.ry, 0, 1));
    return true;
  }

  function makeDraggable(el, key, onMove) {
    if (!el) return null;

    el.classList.add('vp-draggable');
    el.setAttribute('draggable', 'false');
    var imgs = el.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) imgs[i].setAttribute('draggable', 'false');
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var moved = restore(el, key);
    var start = null;
    var origin = null;
    var dragging = false;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      var r = el.getBoundingClientRect();
      start = { x: e.clientX, y: e.clientY, id: e.pointerId };
      origin = { x: r.left, y: r.top };
      dragging = false;
    });

    el.addEventListener('pointermove', function (e) {
      if (!start || e.pointerId !== start.id) return;
      var dx = e.clientX - start.x;
      var dy = e.clientY - start.y;
      if (!dragging) {
        if (Math.abs(dx) < THRESHOLD && Math.abs(dy) < THRESHOLD) return;
        dragging = true;
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
        el.classList.add('vp-dragging');
      }
      e.preventDefault();
      place(el, origin.x + dx, origin.y + dy);
      moved = true;
      if (onMove) onMove();
    });

    function end(e) {
      if (!start || e.pointerId !== start.id) return;
      if (dragging) {
        var r = el.getBoundingClientRect();
        var free = freeSpace(el);
        var pos = {
          rx: free.x > 0 ? clamp((r.left - MARGIN) / free.x, 0, 1) : 0,
          ry: free.y > 0 ? clamp((r.top - MARGIN) / free.y, 0, 1) : 0
        };
        store(key, pos);
        park(el, pos.rx, pos.ry);
        suppressUntil = Date.now() + SUPPRESS_MS;
        suppressEl = el;
        el.classList.remove('vp-dragging');
      }
      start = null;
      dragging = false;
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);

    return { isMoved: function () { return moved; } };
  }

  // A drag must not also count as a tap (opening WhatsApp / toggling the menu).
  // Capture on window so this runs before the buttons' own click handlers.
  window.addEventListener('click', function (e) {
    if (suppressEl && Date.now() < suppressUntil && suppressEl.contains(e.target)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      suppressEl = null;
    }
  }, true);

  makeDraggable(document.querySelector('.whatsapp-float'), 'vipetPos:whatsapp');

  var a11yBtn = document.getElementById('vpaBtn');
  var a11yPanel = document.getElementById('vpaPanel');

  // Once the button has been moved, open the panel beside it instead of at
  // the fixed bottom-left spot: above the button if it fits, else below.
  function placePanel() {
    if (!a11yBtn || !a11yPanel || !a11y || !a11y.isMoved()) return;
    if (a11yPanel.getAttribute('data-open') !== 'true') return;
    var b = a11yBtn.getBoundingClientRect();
    var gap = 10;
    var top = b.top - a11yPanel.offsetHeight - gap;
    if (top < MARGIN) top = b.bottom + gap;
    place(a11yPanel, b.left + b.width / 2 - a11yPanel.offsetWidth / 2, top);
  }

  var a11y = makeDraggable(a11yBtn, 'vipetPos:a11y', placePanel);
  // Registered after the menu's own handler, so the panel is already open here.
  if (a11yBtn) a11yBtn.addEventListener('click', placePanel);
  window.addEventListener('resize', placePanel);
})();
